import { TEMPLATE_SIGNUP_INTENT_TTL_MS } from "@cohesive/ui-components";

/**
 * Mirrors the ui-components stash key. That module only exposes a
 * consume-on-read; the first-login sequence has to look without taking.
 */
const TEMPLATE_SIGNUP_INTENT_KEY = "cohesive:template-signup-intent";

export function hasFreshTemplateSignupIntent(
  now: number = Date.now(),
): boolean {
  try {
    const raw = window.sessionStorage.getItem(TEMPLATE_SIGNUP_INTENT_KEY);
    if (!raw) return false;
    const { ts } = JSON.parse(raw) as { ts?: unknown };
    return typeof ts === "number" && now - ts <= TEMPLATE_SIGNUP_INTENT_TTL_MS;
  } catch {
    return false;
  }
}
